import 'wow.js/css/libs/animate.css';
import './App.css';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import Services from './Components/Services';
import Particle from './Components/Particle';
import Businesses from './Components/Businesses';
import Intro from './Components/Intro';
import ContactForm from './Components/ContactForm';
import Footer from './Components/Footer';



function App() {
  return (
   <div>

   <Navbar/>
   <Particle/>
   <Hero/>
   <Intro/>
   <Services/>
   <Businesses/>
  <ContactForm/>
  <Footer/>

   </div>
  );
}

export default App;
